import React, { FC } from "react";
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import Markdown from "@components/Markdown";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";

interface Props {
  content: {
    header: Array<string>;
    rows: Array<{ data: Array<string> }>;
    caption?: string;
  };
}

const PlainTable: FC<Props> = ({ content }) => {
  return (
    <Box sx={{ maxWidth: "calc(100vw - 48px)" }}>
      <Stack mb={4} sx={{ overflowX: "auto" }}>
        {content.caption && (
          <Typography
            variant="caption"
            sx={{
              marginBottom: "12px",
              fontSize: "14px",
              lineHeight: "20px",
              fontWeight: "400",
              color: "#000",
            }}
          >
            {content.caption}
          </Typography>
        )}
        <TableContainer
          sx={{
            width: "100%",
            padding: "16px",
            backgroundColor: Colors.BlueGrey,
            borderRadius: "15px",
          }}
        >
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: Colors.PrimaryContrast,
                  borderRadius: "8px",
                }}
              >
                {content.header.map((label: string, idx) => {
                  return (
                    <TableCell key={`table-head-${idx}`}>{label}</TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {content.rows.map((row: { data: Array<string> }, idx) => {
                return (
                  <TableRow key={`table-row-${idx}`}>
                    {row.data.map((data, cidx) => {
                      return (
                        <TableCell key={`table-cell-${idx}-${cidx}`}>
                          <Markdown content={data} />
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Box>
  );
};

export default PlainTable;
